import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    storyList: [],
    story: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
      status: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.storyList = [];
      state.story = null;
    },
    SET_STORYLIST(state, data) {
      state.storyList = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_STORY(state, data) {
      state.story = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setStory({ commit }, data) {
      commit('SET_STORY', data);
    },

    find({ commit, state }) {
      let url = `/story?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('Story'));
          return response.body;
        })
        .then((response) => {
          commit('SET_STORYLIST', response);
        });
    },

    findById({ commit }, id) {
      return http(`/story/${id}`)
        .then((response) => response.body)
        .then(typeAs('Story'))
        .then((item) => {
          commit('SET_STORY', item);
        });
    },

    destroy(_, id) {
      return http(`/story/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/story/${id}`, { method: 'PUT', data })
        : http('/story', { method: 'POST', data });
      console.log(data);
      return request.then((response) => response.body);
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/story/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },
    // 取得所屬Application
    getApplications(_, id) {
      const request = id
        ? http(`/applicationbyid/${id}`)
        : http('/applications/all');
      return request.then((response) => response.body);
    },

    /* 供 Application 綁定Success Case 的搜尋/選取清單 (不分頁, 可依關鍵字篩選) */
    allStories(_, keyword) {
      const query = keyword ? `?keyword=${encodeURIComponent(keyword)}` : '';
      return http(`/story/all${query}`).then((response) => response.body);
    },
  },
};
